<div class="requested-doc-field-container bl-padding-top--16 bl-margin-bottom--16">
  <fieldset>
    <div>
      <legend [id]="'upload-label-' + uniqueId" [class.bl-required]="isRequired" class="bl-font-size--16 bl-font-weight--800 bl-label">
        {{ field.label }}
      </legend>
    </div>
    <div class="bl-row">
      <div class="bl-col-12 bl-col-sm-9" [id]="'upload-desc-' + uniqueId">
        <div class="bl-margin-bottom--8 bl-margin-bottom-sm--0 bl-margin-top--4 bl-font-size--14">
          {{ field?.description }}
        </div>
        <div class="bl-display--flex bl-margin-top--4" *ngFor="let doc of requestedDocs; let i = index">
          <div class="bl-margin-right--8 bl-font-size--base bl-font-color--success cu-check-circle-solid"></div>
          <div
            class="bl-font-size--14 bl-font-weight--800 bl-label bl-flex--auto bl-display--flex bl-flex-direction--column bl-justify-content--center"
          >
            {{ doc?.fileName }}
          </div>
        </div>
      </div>
      <div class="bl-col-12 bl-col-sm-3">
        <button 
          [id]="'upload-button-' + uniqueId" 
          type="button"
          [attr.aria-describedby]="'applicant-name-' + uniqueId + ' ' + 'upload-label-' + uniqueId + ' ' + 'upload-desc-' + uniqueId"
          (click)="uploadDoc()"
          class="bl-button bl-btn-upload bl-float-md--right bl-width--100 bl-width-sm--auto"
          [ngClass]="isAddMoreFiles ? 'bl-requested-doc-upload-more' : 'bl-requested-doc-upload'">
          
          @if(isAddMoreFiles) {
          <i class="cu-icon bl-font-color--success cu-add-circle-solid"></i>
          }

          <span class="bl-font-size--12">
            {{ isAddMoreFiles ? 
              ('requestedDocument/addMoreUploadDocButton' | dictionary) 
              : ('requestedDocument/uploadDocButton' | dictionary) }}
          </span>
        </button>
      </div>
    </div>
  </fieldset>
</div>
<ea-slide-in-panel
  [(isSlidePanelVisible)]="showFileUpload"
  [slidePanelTitle]="documentPageHeader()"
  (isSlidePanelVisibleChange)="onDocumentClose()"
  [openPanelElementId]="'upload-button-' + uniqueId"
  class="full-panel"
>
  <div class="bl-max-width--1136 bl-width--100 bl-padding-sm--24">
    <ea-alert
      alertId="alert"
      [alertStatus]="alertStatus"
      [showAlert]="showAlert"
      [heading]="'requestedDocument/slideInPanel/globalError' | dictionary"
      [message]="alertMessage"
      (closeEvent)="closeAlert()"
      [ngClass]="{ 'bl-display--block bl-margin-bottom--16 bl-max-width--tablet-width': showAlert }"
    >
    </ea-alert>
    <h3 class="bl-margin-bottom--4">
      <span [id]="'applicant-name-' + uniqueId" class="bl-font-color--black bl-font-weight--800 bl-font-size--22 bl-margin-bottom--0 bl-display--block">
        {{ applicant?.firstName }} {{ applicant?.lastName }}
      </span>
      <span class="bl-font-color--steel bl-font-weight--800 bl-font-size--18 bl-margin-bottom--0 bl-display--block">
        {{ field.label }}
      </span>
    </h3>
    <p class="bl-text-style--default-text-1 bl-width--100 bl-width-xl--75 bl-margin-bottom--0">
      {{ field?.description ? field?.description : ('requestedDocument/slideInPanel/headerDescription' | dictionary) }}
    </p>

    <section class="bl-display-xl--flex bl-margin-top--32">
      <!-- Upload card-->
      <section class="bl-width--100 bl-width-xl--75 bl-block-module bl-display-md--flex bl-padding--16 bl-padding-md--40 bl-margin-bottom--32">
        <!-- Document icon -->
        <figure class="bl-width--100 bl-width-md--25 bl-margin-bottom--24 bl-padding-right-md--24 bl-text-align--center">
          <svg
            class="bl-max-width--100"
            width="120"
            height="120"
            viewBox="0 0 120 120"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <circle cx="60" cy="60" r="60" fill="#E5F0FC" />
            <g filter="url(#filter0_d_58498_403720)">
              <path
                d="M84.6354 28H34.6666C33.9302 28 33.3333 28.597 33.3333 29.3333V90.6667C33.3333 91.403 33.9302 92 34.6666 92H84.6354C85.3718 92 85.9688 91.403 85.9688 90.6667V29.3333C85.9688 28.597 85.3718 28 84.6354 28Z"
                fill="black"
              />
            </g>
            <path
              d="M84.6354 28H34.6666C33.9302 28 33.3333 28.597 33.3333 29.3333V90.6667C33.3333 91.403 33.9302 92 34.6666 92H84.6354C85.3718 92 85.9688 91.403 85.9688 90.6667V29.3333C85.9688 28.597 85.3718 28 84.6354 28Z"
              fill="white"
            />
            <path
              d="M76.9282 36.374H42.3737C42.0055 36.374 41.707 36.6725 41.707 37.0407V53.6513C41.707 54.0195 42.0055 54.3179 42.3737 54.3179H76.9282C77.2964 54.3179 77.5949 54.0195 77.5949 53.6513V37.0407C77.5949 36.6725 77.2964 36.374 76.9282 36.374Z"
              fill="#43A6DD"
            />
            <path
              d="M76.2146 64.4858H43.0873C42.325 64.4858 41.707 63.8163 41.707 62.9904C41.707 62.1646 42.325 61.4951 43.0873 61.4951H76.2146C76.9769 61.4951 77.5949 62.1646 77.5949 62.9904C77.5949 63.8163 76.9769 64.4858 76.2146 64.4858Z"
              fill="#B3B3B3"
            />
            <path
              d="M76.2146 74.0561H43.0873C42.325 74.0561 41.707 73.3866 41.707 72.5608C41.707 71.7349 42.325 71.0654 43.0873 71.0654H76.2146C76.9769 71.0654 77.5949 71.7349 77.5949 72.5608C77.5949 73.3866 76.9769 74.0561 76.2146 74.0561Z"
              fill="#B3B3B3"
            />
            <path
              d="M58.2707 83.6264H43.0873C42.325 83.6264 41.707 82.9569 41.707 82.1311C41.707 81.3052 42.325 80.6357 43.0873 80.6357H58.2707C59.033 80.6357 59.651 81.3052 59.651 82.1311C59.651 82.9569 59.033 83.6264 58.2707 83.6264Z"
              fill="#B3B3B3"
            />
            <defs>
              <filter
                id="filter0_d_58498_403720"
                x="30.3333"
                y="26"
                width="60.6355"
                height="72"
                filterUnits="userSpaceOnUse"
                color-interpolation-filters="sRGB"
              >
                <feFlood flood-opacity="0" result="BackgroundImageFix" />
                <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
                <feOffset dx="1" dy="2" />
                <feGaussianBlur stdDeviation="2" />
                <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.100628 0" />
                <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_58498_403720" />
                <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_58498_403720" result="shape" />
              </filter>
            </defs>
          </svg>
        </figure>
        <!-- Upload component -->
        <!-- If scanBaseURL is an explicit null or empty string, that is supported config in doc upload (don't scan) -->
        <div *ngIf="docUploadConfig?.scanBaseURL != undefined" class="bl-width--100 bl-width-md--75">
          <ea-document-upload
            [config]="docUploadConfig"
            [loader]="inprogress"
            [submitStatusFlag]="submitSuccess"
            (documentCancel)="close()"
            (documentSave)="onSaveclick($event)"
          ></ea-document-upload>
        </div>
      </section>
  
      <!-- Help text -->
      <aside class="bl-width--100 bl-width-xl--25 bl-margin-left-lg--24">
        <section class="bl-display--flex bl-align-items--flex-start bl-margin-bottom--24">
          <i class="cu-question-circle-solid cu-icon--16 bl-font-color--primary-light bl-margin-top--4"></i>
          <div class="bl-margin--0 bl-margin-left--16">
            <h4 class="bl-text-style--tertiary-text-2 bl-display--block bl-margin-bottom--4">{{ 'requestedDocument/slideInPanel/uploadInfoHeading' | dictionary }}</h4>
            <span class="bl-text-style--tertiary-text-1 bl-display--block">{{ 'requestedDocument/slideInPanel/uploadInfoDescription' | dictionary }}</span>
          </div>
        </section>
  
        <section class="bl-display--none bl-display-sm--flex bl-align-items--flex-start bl-margin-bottom--24">
          <img src="/assets/images/lightbulb.svg" width="16px" class="bl-margin-top--4" alt="" aria-hidden="true" />
          <div class="bl-margin--0 bl-margin-left--16">
            <h4 class="bl-text-style--tertiary-text-2 bl-display--block bl-margin-bottom--4">{{ 'requestedDocument/slideInPanel/uploadTipHeading' | dictionary }}</h4>
            <span class="bl-text-style--tertiary-text-1 bl-display--block">{{ 'requestedDocument/slideInPanel/uploadTipDescription' | dictionary }}</span>
          </div>
        </section>
  
        <section class="bl-display--flex bl-align-items--flex-start bl-margin-bottom--24">
          <img src="/assets/images/lock.svg" width="16px" class="bl-margin-top--4" alt="" aria-hidden="true" />
          <p class="bl-text-style--tertiary-text-1 bl-margin--0 bl-margin-left--16">
            {{ 'requestedDocument/slideInPanel/securityText' | dictionary }}
          </p>
        </section>
      </aside>
    </section>
  </div>
</ea-slide-in-panel>
